import React, { useState } from 'react';
import Spacer from 'features/shared/Spacer';
import SwitchTabs, { BluePillsTab, SwitchTabsType } from 'features/shared/SwitchTabs';
import Chart from 'features/monitoring/charts/Chart';
import * as am4core from '@amcharts/amcharts4/core';
import { Plate, Row, SubHeader } from 'features/shared/ui/Page';
import styled from 'styled-components';

import { Subject, subjectOptions } from 'features/monitoring/models';
import LoaderComponent from 'features/shared/Loader';
import { useChartsProps } from 'features/monitoring/charts/useChartsProps';
import { FetchMonitoringData } from '../hooks/useFetchMonitoringData';
import { useClickStreamContext } from 'features/shared/ClickStream';

const studentsChartColors = [
  am4core.color('rgb(197, 217, 91)'),
  am4core.color('rgba(197, 217, 91, 0.3)'),
  am4core.color('rgb(149, 195, 89)'),
  am4core.color('rgba(149, 195, 89, 0.3)'),
  am4core.color('rgb(81, 178, 157)'),
  am4core.color('rgba(81, 178, 157, 0.3)'),
];

const teachersChartColors = [
  am4core.color('rgb(75, 166, 238)'),
  am4core.color('rgba(75, 166, 238, 0.3)'),
  am4core.color('rgb(157, 134, 231)'),
  am4core.color('rgba(157, 134, 231, 0.3)'),
  am4core.color('rgb(223, 90, 162)'),
  am4core.color('rgba(223, 90, 162, 0.3)'),
];

const Component = ({ tests, participants }: FetchMonitoringData) => {
  const [subject, setSubject] = useState(subjectOptions[0]);
  const { logPageEvent } = useClickStreamContext();

  const chartsProps = useChartsProps(participants, tests!, subject.id);

  return (
    <Plate>
      {!chartsProps ? (
        <LoaderComponent />
      ) : (
        <>
          <SubHeader>Результаты тестирования в школах</SubHeader>
          <Spacer size={40} />
          <SwitchTabs
            tabRenderer={BluePillsTab}
            values={subjectOptions}
            value={subject}
            handleChange={(value) => {
              setSubject(value);
              logPageEvent({
                eventType: 'monitoring_test_results_tab_' + value.id,
                eventInfo: 'Срезы знаний|Результаты тестирования:  Перешел на вкладку ' + value.label,
              });
            }}
            type={SwitchTabsType.pills}
          />
          {/*<Spacer size={24}/>
				<SchoolSelector />
				взять компонент из школ активность по сервисам
				*/}
          <Spacer size={40} />
          <Row>
            <Chart
              data={chartsProps.studentSamples}
              title="Ученики, прошедшие тестирование"
              yAxisTitle="Ученики"
              colors={studentsChartColors}
            />
            <Chart
              data={chartsProps.teacherSamples}
              title="Учителя, проводившие тесты"
              yAxisTitle="Учителя"
              colors={teachersChartColors}
            />
          </Row>
        </>
      )}
    </Plate>
  );
};

export default Component;
